var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sale-list" },
    [
      _c(
        "Row",
        _vm._l(_vm.saleListConfig, function (item, index) {
          return _c("Col", { key: index, attrs: { span: item.width } }, [
            item.content.length > 1
              ? _c("div", { staticClass: "sale-list-item" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.isShow,
                          expression: "item.isShow",
                        },
                      ],
                      staticClass: "sale-icon",
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: item.url,
                          width: item.img_width,
                          height: item.img_height,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sale-target-content" },
                    _vm._l(item.content, function (contentItem, acindex) {
                      return _c(
                        "div",
                        { key: acindex, staticClass: "content-item" },
                        [
                          _c("p", [_vm._v(_vm._s(contentItem.value))]),
                          _vm._v(" "),
                          _c("span", { attrs: { title: contentItem.label } }, [
                            _vm._v(_vm._s(contentItem.label)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _c("div", { staticClass: "sale-list-item" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.isShow,
                          expression: "item.isShow",
                        },
                      ],
                      staticClass: "sale-icon",
                      staticStyle: { "border-right": "none" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: item.url,
                          width: item.img_width,
                          height: item.img_height,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  item.content.length > 0
                    ? _c(
                        "div",
                        { staticClass: "sale-target-content" },
                        _vm._l(item.content, function (contentItem, acindex) {
                          return _c(
                            "div",
                            { key: acindex, staticClass: "content-item" },
                            [
                              _c("p", [_vm._v(_vm._s(contentItem.value))]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { attrs: { title: contentItem.label } },
                                [_vm._v(_vm._s(contentItem.label))]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }